import { render } from "./HomeView.vue?vue&type=template&id=24c53a50&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=24c53a50&lang=css"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__